// src/components/Consultorios.js (Versión Compacta)

import React from 'react';
import { motion } from 'framer-motion';
import { consultoriosData } from '../data/hospitalData';
import { MapPin, Phone, Clock, MessageCircle } from 'lucide-react';
import '../styles/Consultorios.css';

const Consultorios = () => {
  return (
    <div className="consultorios-page-wrapper">
      <div className="consultorios-container">
        <header className="consultorios-header">
          <h1>Nuestros Consultorios Externos</h1>
          <p>Encontrá la sede más cercana y contactanos para solicitar tu turno.</p>
        </header>

        <motion.div 
          className="consultorios-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={{
            visible: { transition: { staggerChildren: 0.2 } }
          }}
        >
          {consultoriosData.map((consultorio) => {
            const whatsappLink = `https://wa.me/${consultorio.whatsappNumber}?text=Hola,%20quisiera%20solicitar%20un%20turno%20en%20los%20consultorios%20de%20${consultorio.nombre}.`;
            
            return (
              <motion.div
                key={consultorio.id}
                className="consultorio-card"
                variants={{
                  hidden: { opacity: 0, y: 40 },
                  visible: { opacity: 1, y: 0 }
                }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                <div 
                  className="consultorio-image" 
                  style={{ backgroundImage: `url(${consultorio.imagenUrl})` }}
                >
                  <h2 className="consultorio-nombre">{consultorio.nombre}</h2>
                </div>

                <div className="consultorio-body">
                  <div className="consultorio-content">
                      <div className="info-item">
                          <MapPin size={18} className="info-icon" />
                          <span>{consultorio.direccion}</span>
                      </div>
                      <a href={`tel:${consultorio.telefono}`} className="info-item interactive">
                          <Phone size={18} className="info-icon" />
                          <span>{consultorio.telefono}</span>
                      </a>
                      <div className="info-item">
                          <Clock size={18} className="info-icon" />
                          <span>{consultorio.horarios}</span>
                      </div>
                  </div>
                  <div className="consultorio-map">
                    <iframe
                      src={consultorio.mapaUrl}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`Mapa de ${consultorio.nombre}`}
                    ></iframe>
                  </div>
                </div>

                <a 
                  href={whatsappLink} 
                  className="whatsapp-button"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <MessageCircle size={20} />
                  <span>Solicitar Turno por WhatsApp</span>
                </a>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
};

export default Consultorios;